export function stringPrototypeMutations() {
  /*****************************************************************************
   * String.prototype.format */
  /**
   * @ngdoc    method
   * @name     format
   * @methodOf polyfill.String
   * @param    {object...}  args  Replacement values.
   * @returns  {string}     Formatted string.
   * @description
   * Enhance the String prototype to include a method to replace '{#}' with
   * the corresponding argument for the #, where # is a non-negative integer.
   * Consecutive braces will be seen as escaped characters and will not match
   * as a replacement marker, i.e. "{{1}}".
   *****************************************************************************/
  String.prototype.format = function () {
    var args = arguments;

    /*------------------------------------------*/
    /* Perform replace on appropriate locations */
    /*------------------------------------------*/
    var repl = this.replace(/({+)?{(\d+)}(}+)?/g, function ($0, $1, $2, $3) {
      /*------------------------------------------------*/
      /* Don't replace if either brace has been escaped */
      /*------------------------------------------------*/
      if ($1 || $3) return $0;

      /*--------------------------------------------------*/
      /* At this point, a replacement has been indicated, */
      /* check that arguments have been provided          */
      /*--------------------------------------------------*/
      if (args.length == 0) throw new Error('No replacement values provided');

      /*----------------------------------------------------------*/
      /* Verify a value has been provided for the indicated index */
      /*----------------------------------------------------------*/
      var idx = Number($2);
      if (idx + 1 > args.length)
        throw new Error('No parameter available for index: ' + $2);

      return args[idx];
    });

    /*-----------------------------------*/
    /* Convert escaped ( {{ | }}) braces */
    /*-----------------------------------*/
    repl = repl.replace('{{', '{').replace('}}', '}');

    return repl;
  };

  /*****************************************************************************
   * String.prototype.parseNumber */
  /**
   * @ngdoc    method
   * @name     parseNumber
   * @methodOf polyfill.String
   * @returns  {Number} Numeric value from the string content
   * @description
   * Enhance the string class to return a numeric value. A trim is applied as
   * empty string/white space are converted to 0 when used with the Number function.
   * Commas are removed before conversion checking.
   *****************************************************************************/
  String.prototype.parseNumber = function () {
    var trimmed = this.trim().replace(/,/g, '');

    if (trimmed.length == 0) return NaN;
    else return Number(trimmed);
  };
}
